<template lang="pug">
	.easy-creative--tag-editor.flex-col.space-medium
		DxTextBox(ref="text", :value.sync="text", stylingMode="filled", :placeholder="$tCaption('Type something here to add an adjective..')", :acceptCustomValue="true", @value-changed="e => addTag(e.value)", @keyDown="checkLastKey")
		.flex-col.space(v-if="selectedItems.length")
			.upper.grey.font-lg {{title || $tCaption('Suggested keywords')}}
			.flex-row.space-medium.wrap
				.tag.flex-row.space.align-center(v-for="adj in selectedItems")
					.font-lg {{adj}}
					.adt-button.rounded.flex-col.align-center.center.padded.clickable.hoverable(@click="$Data.toggleSelectedIdInArray(adj, selectedItems)")
						fas(icon="times")
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'asy-creative--tag-editor',
		props: ['value', 'title'],
		components: {
			DxTextBox
		},
		data() {
			return {
				selectedItems: Array.isArray(this.value) ? this.value : `${(this.value || '')}`.split(',').map(f => (f || '').trim()),
				text: null,
				innerChange: false
			};
		},
		computed: {
			
		},
		watch: {
			selectedItems: {
				handler() {
					this.innerChanging(() => {
						this.$emit('change', Array.isArray(this.value) ? this.selectedItems : this.selectedItems.join(','), this.selectedItems);
					});
				},
				deep: true
			},
			value() {
				this.calcSelectedItems();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeTagEditor = this;
			
		},
		methods: {
			innerChanging(callback) {
				if (this.innerChange) return;
				this.innerChange = true;
				setImmediate(() => this.innerChange = false);
				callback();
			},
			calcSelectedItems() {
				this.innerChanging(() => {
					this.selectedItems = Array.isArray(this.value) ? this.value : `${(this.value || '')}`.split(',').map(f => (f || '').trim())
				});
			},
			addTag(text) {
				const val = `${text || this.text || ''}`;
				if (val) {
					const split = val.split(',').filter(f => f);
					this.selectedItems.push(...split);
				}
				setImmediate(() => {
					this.$refs.text.instance._clearValue();
				});
			},
			checkLastKey(e) {
				if ([','].includes(e.event.key)) {
					this.addTag(this.$refs.text.instance._input()[0].value);
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--tag-editor {
	}
</style>
